var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 11.1315 6.70557",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M0.55718 0.574065L5.7087 5.57406L10.5572 0.574065",
    stroke: "var(--stroke-0, #636363)",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqArrow);
export default __webpack_public_path__ + "static/media/faq-arrow.55bf0f6450f7a1fefcce6ae48dbcfd34.svg";
export { ForwardRef as ReactComponent };